
/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoRequestOrderLock {
    constructor() {
        //无参构造函数
    }

    [proName: string]: any;
    /**
     * 订单主键
     */
    OrderId?: string[];
    /**
     * 委托书主键
     */
    PoolId?: string[];
    /**
     * 账单主键
     */
    BillId?: string[];
}

/**
 * -表单校验
 */
export const DtoRequestOrderLockRules = {
}
